import _objectSpread from "/root/Etro/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/root/Etro/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/root/Etro/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { posToDOMRect, Extension } from '@tiptap/core';
import { Plugin, PluginKey } from 'prosemirror-state';
import tippy from 'tippy.js';

var FloatingMenuView = /*#__PURE__*/function () {
  function FloatingMenuView(_ref) {
    var _this = this;

    var editor = _ref.editor,
        element = _ref.element,
        view = _ref.view,
        _ref$tippyOptions = _ref.tippyOptions,
        tippyOptions = _ref$tippyOptions === void 0 ? {} : _ref$tippyOptions,
        shouldShow = _ref.shouldShow;

    _classCallCheck(this, FloatingMenuView);

    this.preventHide = false;

    this.shouldShow = function (_ref2) {
      var view = _ref2.view,
          state = _ref2.state;
      var selection = state.selection;
      var $anchor = selection.$anchor,
          empty = selection.empty;
      var isRootDepth = $anchor.depth === 1;
      var isEmptyTextBlock = $anchor.parent.isTextblock && !$anchor.parent.type.spec.code && !$anchor.parent.textContent;

      if (!view.hasFocus() || !empty || !isRootDepth || !isEmptyTextBlock || !_this.editor.isEditable) {
        return false;
      }

      return true;
    };

    this.mousedownHandler = function () {
      _this.preventHide = true;
    };

    this.focusHandler = function () {
      // we use `setTimeout` to make sure `selection` is already updated
      setTimeout(function () {
        return _this.update(_this.editor.view);
      });
    };

    this.blurHandler = function (_ref3) {
      var event = _ref3.event;

      var _a;

      if (_this.preventHide) {
        _this.preventHide = false;
        return;
      }

      if ((event === null || event === void 0 ? void 0 : event.relatedTarget) && ((_a = _this.element.parentNode) === null || _a === void 0 ? void 0 : _a.contains(event.relatedTarget))) {
        return;
      }

      _this.hide();
    };

    this.tippyBlurHandler = function (event) {
      _this.blurHandler({
        event
      });
    };

    this.editor = editor;
    this.element = element;
    this.view = view;

    if (shouldShow) {
      this.shouldShow = shouldShow;
    }

    this.element.addEventListener('mousedown', this.mousedownHandler, {
      capture: true
    });
    this.editor.on('focus', this.focusHandler);
    this.editor.on('blur', this.blurHandler);
    this.tippyOptions = tippyOptions; // Detaches menu content from its current parent

    this.element.remove();
    this.element.style.visibility = 'visible';
  }

  _createClass(FloatingMenuView, [{
    key: "createTooltip",
    value: function createTooltip() {
      var editorElement = this.editor.options.element;
      var editorIsAttached = !!editorElement.parentElement;

      if (this.tippy || !editorIsAttached) {
        return;
      }

      this.tippy = tippy(editorElement, _objectSpread({
        duration: 0,
        getReferenceClientRect: null,
        content: this.element,
        interactive: true,
        trigger: 'manual',
        placement: 'right',
        hideOnClick: 'toggle'
      }, this.tippyOptions)); // maybe we have to hide tippy on its own blur event as well

      if (this.tippy.popper.firstChild) {
        this.tippy.popper.firstChild.addEventListener('blur', this.tippyBlurHandler);
      }
    }
  }, {
    key: "update",
    value: function update(view, oldState) {
      var _a, _b, _c;

      var state = view.state;
      var doc = state.doc,
          selection = state.selection;
      var from = selection.from,
          to = selection.to;
      var isSame = oldState && oldState.doc.eq(doc) && oldState.selection.eq(selection);

      if (isSame) {
        return;
      }

      this.createTooltip();
      var shouldShow = (_a = this.shouldShow) === null || _a === void 0 ? void 0 : _a.call(this, {
        editor: this.editor,
        view,
        state,
        oldState
      });

      if (!shouldShow) {
        this.hide();
        return;
      }

      (_b = this.tippy) === null || _b === void 0 ? void 0 : _b.setProps({
        getReferenceClientRect: ((_c = this.tippyOptions) === null || _c === void 0 ? void 0 : _c.getReferenceClientRect) || function () {
          return posToDOMRect(view, from, to);
        }
      });
      this.show();
    }
  }, {
    key: "show",
    value: function show() {
      var _a;

      (_a = this.tippy) === null || _a === void 0 ? void 0 : _a.show();
    }
  }, {
    key: "hide",
    value: function hide() {
      var _a;

      (_a = this.tippy) === null || _a === void 0 ? void 0 : _a.hide();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _a, _b;

      if ((_a = this.tippy) === null || _a === void 0 ? void 0 : _a.popper.firstChild) {
        this.tippy.popper.firstChild.removeEventListener('blur', this.tippyBlurHandler);
      }

      (_b = this.tippy) === null || _b === void 0 ? void 0 : _b.destroy();
      this.element.removeEventListener('mousedown', this.mousedownHandler, {
        capture: true
      });
      this.editor.off('focus', this.focusHandler);
      this.editor.off('blur', this.blurHandler);
    }
  }]);

  return FloatingMenuView;
}();

var FloatingMenuPlugin = function FloatingMenuPlugin(options) {
  return new Plugin({
    key: typeof options.pluginKey === 'string' ? new PluginKey(options.pluginKey) : options.pluginKey,
    view: function view(_view) {
      return new FloatingMenuView(_objectSpread({
        view: _view
      }, options));
    }
  });
};

var FloatingMenu = Extension.create({
  name: 'floatingMenu',

  addOptions() {
    return {
      element: null,
      tippyOptions: {},
      pluginKey: 'floatingMenu',
      shouldShow: null
    };
  },

  addProseMirrorPlugins() {
    if (!this.options.element) {
      return [];
    }

    return [FloatingMenuPlugin({
      pluginKey: this.options.pluginKey,
      editor: this.editor,
      element: this.options.element,
      tippyOptions: this.options.tippyOptions,
      shouldShow: this.options.shouldShow
    })];
  }

});
export { FloatingMenu, FloatingMenuPlugin, FloatingMenuView, FloatingMenu as default };